import React, { useCallback, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Form, Grid, Icon, Label } from 'semantic-ui-react'
import { useDocument } from '../../../hooks/useDocument'
import { getPayloadforDeleteDoc, getPayloadforRoutingCountry } from '../helper'
import PopUpIcon from '../../../../commonComponents/formComponents/PopUpIcon'
import RoutingModal from '../../../../commonComponents/routingModal'
import { useEvent } from '../../../hooks/useEvent'

const CountryOfROuting = ({isFormDisabled,currentJobState}) => {
  const {deleteItem, updateItem, saveItem } = useDocument({
    actionType: 'CDS_HEADER',
    tableName: 'routingCountry',
    containerKey: 'header',
  })
  const {saveForm,deleteForm} = useEvent('header',true)


  const dispatch = useDispatch()

  const routingCountry= useSelector((state) => state.Shipment?.routingCountry) || []
  const routingCountries = useSelector((state) => state.DropDownValues.countryTypes)

  const updateData =(response)=>{
    dispatch({
      type:"ADD_AFTER_EXITING_ROUTING_COUNTRY",
      payload:response
    })
  }

  const saveDataHadler = useCallback(async(payload)=>{
    try{
      const response = await saveForm(payload)
      if(response){
        const res= response?.header['routingCountry']
        updateData(res)
      }
    }catch(e){

    }

  },[saveForm])
  
  const addItem = async(orderNumber=0) =>{
        let odNum = orderNumber===0 ? routingCountry.length +1 : orderNumber +1
        const addItemPayload = getPayloadforRoutingCountry('routingCountry',odNum)
        saveDataHadler(addItemPayload)
  }

const getText =(countryCode)=>{
    let routingCountry = routingCountries.find(item=>item.value===countryCode)
    return routingCountry?.text 
}

const deleteAddnDetails = useCallback(
  async (id) => {
    try{
      let payload = getPayloadforDeleteDoc(id, 'routingCountry')
      let response = await deleteForm(payload)
      if(response){
        const res= response?.header['routingCountry']
        updateData(res)
      }
    }catch(e){}

  },
  [deleteItem]
)


  const setDisplayRoutingCountryCode = (valueList,currentJobState) => {
    let list = [];
    if (valueList && valueList.length > 0) {
      valueList.map((item, index) => {
        return list.push(
          <Label key={item?.id} 
          isFormDisabled={isFormDisabled}
          >
            {item?.countryCode}
            <PopUpIcon icon='info circle' style={{marginLeft:'2px', marginRight:'2px'}} popupText={getText(item?.countryCode)} />
            <Icon
              id={`${index}-deleteContainerOuter`}
              disabled={isFormDisabled || currentJobState==='STATE_ENTRY_AMEND_IN_PROCESS'}
              name="delete"
              onClick={() => {
                deleteAddnDetails(item?.id)
              }}
            />
          </Label>
        );
      });
    }
    return list;
  }


  return (
    <Form.Group className='float-container'>
   <Grid.Row  className='container-box'>
   <Grid.Column
          width="16"
          className="divFormFeild  border-bottom   b-rw-0  b-blr-5 "
          style={{
            border: "1px solid #1765AE",
            borderRadius: "5px",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
      <label className='label-address'>
            <span className='ui black label input-box-number'>5/18</span>
            Countries Of Routing Codes
          </label>
        <Label.Group style={{ marginLeft: "5px",marginTop: "20px"}}>
            {setDisplayRoutingCountryCode(routingCountry,currentJobState)}
            <RoutingModal
              isFormDisabled={isFormDisabled || currentJobState==='STATE_ENTRY_AMEND_IN_PROCESS' }
              headerName='Routing Country'        
              valueKey='countryCode'
              limit={99}
              AddItem={addItem}
              saveData={saveItem} 
              updateData={updateItem} 
              deleteData={deleteAddnDetails}  
              dataList={routingCountry}
              dataSource={routingCountries}
              fieldType={'dropdown'}
              saveRearrange={saveDataHadler}
              draggable={true}
            />
          </Label.Group>
        </Grid.Column>
   </Grid.Row>


    </Form.Group>
  )
}

export default React.memo(CountryOfROuting);
